export const HOME = {
  emergentLink: "emergent-link",
};

export const NAV = {
  navbar: "navbar",
  logo: "nav-logo",
  servicesLink: "nav-services-link",
  metricsLink: "nav-metrics-link",
  resourcesLink: "nav-resources-link",
  contactLink: "nav-contact-link",
  bookConsultationBtn: "nav-book-consultation-btn",
  mobileMenuBtn: "nav-mobile-menu-btn",
  mobileMenu: "nav-mobile-menu",
};

export const HERO = {
  section: "hero-section",
  heading: "hero-heading",
  tagline: "hero-tagline",
  description: "hero-description",
  bookConsultationBtn: "hero-book-consultation-btn",
  learnMoreBtn: "hero-learn-more-btn",
};

export const SERVICES = {
  section: "services-section",
  overline: "services-overline",
  heading: "services-heading",
  revealCard: "services-reveal-card",
  rewireCard: "services-rewire-card",
  rebuildCard: "services-rebuild-card",
};

export const METRICS = {
  section: "metrics-section",
  overline: "metrics-overline",
  heading: "metrics-heading",
};

export const RESOURCES = {
  section: "resources-section",
  overline: "resources-overline",
  heading: "resources-heading",
  manifestoCard: "resources-manifesto-card",
  diagnosticCard: "resources-diagnostic-card",
  manifestoDownload: "resources-manifesto-download-btn",
  diagnosticDownload: "resources-diagnostic-download-btn",
};

export const CONTACT = {
  section: "contact-section",
  overline: "contact-overline",
  heading: "contact-heading",
  form: "contact-form",
  nameInput: "contact-name-input",
  emailInput: "contact-email-input",
  companyInput: "contact-company-input",
  messageInput: "contact-message-input",
  submitBtn: "contact-submit-btn",
  successMessage: "contact-success-message",
};

export const FOOTER = {
  footer: "footer",
  copyright: "footer-copyright",
};
